<template>
  <div>
    <Fieldset
      :legend="translate('skills', 'ucfirst')"
    class="w-full px-5 pb-4 mt-5 bg-white rounded-lg shadow-md border border-color-iron"
    >
      <Skeleton v-if="isLoading && skills" height="1.5rem"></Skeleton>
      <ul
        v-else-if="!isLoading && skills.length > 0"
        class="list-inside list-disc"
      > 
        <li v-for="(skill, index) in skills" :key="index" class="mt-3">
          {{ skill.name }}
        </li> 
      </ul>
      <ul v-else>
        <li>{{ translate("no skills", "ucfirst") }}</li>
      </ul>
    </Fieldset>
  </div>
</template>

<script setup>
import { ref, onMounted, onUpdated } from "vue";
import Fieldset from "primevue/fieldset";
import Skeleton from "primevue/skeleton";
import { translate } from "@/composables/translate";


const props = defineProps({
  skills: {
    type: Array,
    required: true,
    default: ()=> []
  }
});

let skills = ref([]);
let isLoading = ref(false);


onUpdated(() => {
  isLoading.value = false
  if (props.skills.length > 0 ) skills.value = props.skills
})

onMounted(() => {
  isLoading.value = true
});
</script>